export default {
  breadcrumb: {
    studies: 'Studies',
    newStudy: 'New study',
  },
  hero: {
    step: 'Step 01',
    methodology: 'Methodology',
    title: 'How do you want to run this study?',
    description:
      'Each method sets the shape of the rest of setup — what parameters you can sweep, how design points are sampled, and what the run produces. You can change this later, but the rest of the journey will adapt to your choice.',
  },
  comingSoon: 'Coming soon',
  methods: {
    doe: {
      title: 'Design of Experiments',
      subtitle: 'Run every combination',
      description:
        'Take the cartesian product of every discrete value you set. Each combination becomes one CFD case. Best when you already know which operating conditions matter.',
      bullet1: 'Discrete + list parameters',
      bullet2: 'Predictable run count',
      bullet3: 'Results table + sweep charts',
      diagramCaption: 'Cartesian grid · n = 30',
    },
    surrogate: {
      title: 'Surrogate model',
      subtitle: 'Train a fast predictor',
      description:
        'Quasi-random sample over ranges, fit a Gaussian-process surrogate you can query in milliseconds. Add objectives to enable multi-objective Bayesian optimization.',
      bullet1: 'Range parameters',
      bullet2: 'GP model + Pareto front',
      bullet3: 'Adaptive batch selection',
      diagramCaption: 'Sobol · n = 16 · GP fit',
    },
    gci: {
      title: 'Grid Convergence Index',
      subtitle: 'Mesh independence study',
      description:
        'Sweep mesh resolution across coarse, medium, and fine grids; use Richardson extrapolation to estimate discretization error and report a Grid Convergence Index.',
      bullet1: 'Fixed operating point',
      bullet2: '3 mesh refinement levels',
      bullet3: 'Discretization error bounds',
      diagramCaption: 'Richardson extrapolation',
    },
  },
  footer: {
    selectingMethod: 'Selecting a method',
    rest: 'creates the draft and opens the journey — Diagnose · Mesh · Simulate · Analyze. Disabled methods are on the roadmap.',
    back: 'Back',
    creating: 'Creating',
    continue: 'Continue',
  },
} as const;
